import React from 'react';

import { observer } from 'mobx-react';

import { EntitySubscriptionList } from '../../../../components/EntitySubscriptionList/EntitySubscriptionList';
import { LbPagination } from '../../../../../shared/components/ui-components';
import { adminSubscriptionsManagementStore } from '../../../../stores/entitySubscriptionsManagementStore';
import { taxStore } from '../../../../stores/taxStore';

const AdminSubscriptionList = observer(() => {
  const {
    subscriptionsList,
    filterMethods,
    changeActivationStatus,
    changeDisplayToUserStatus,
  } = adminSubscriptionsManagementStore;
  const { appliedTaxRateInfo } = taxStore;

  return (
    <div>
      <EntitySubscriptionList
        subscriptionsList={subscriptionsList}
        changeActivationStatus={changeActivationStatus}
        changeDisplayToUserStatus={changeDisplayToUserStatus}
        sortMethods={{
          getIsActive: filterMethods.getIsSortedBy,
          onSort: filterMethods.handleSort,
          nameKey: 'NAME',
          subscriptionTypeKey: 'SUBSCRIPTION_TYPE',
        }}
        appliedTaxRateInfo={appliedTaxRateInfo}
        isSearchUsed={filterMethods.isSearchUsed}
      />
      <LbPagination
        {...filterMethods.getPaginationProps()}
        elementsPerPage={filterMethods.elementsPerPage}
        totalElements={filterMethods.totalElements}
        variant="inBox"
      />
    </div>
  );
});

export { AdminSubscriptionList };
